import { Notify } from "quasar";

import { ErrorDialog } from "shared/boot/alert";
import { getLocaleText } from "shared/boot/i18n";
import useMediaReleaseRecipient from "shared/composables/useMediaReleaseRecipient";
import { MediaRelease, MediaReleaseRecipient } from "shared/resources";

import { type SuggestedContactsValidate, SuggestedContacts } from "./types";

// eslint-disable-next-line import/prefer-default-export
export class MediaReleaseSuggestedContacts extends SuggestedContacts<MediaRelease> {
  async load(id: string | number): Promise<MediaRelease | undefined> {
    try {
      const response = await MediaRelease.find(id);
      this.item = response.data;

      return this.item;
    } catch (error) {
      ErrorDialog(
        getLocaleText("ai_suggested_contacts_panel.load_media_release_error"),
        error
      );

      return undefined;
    }
  }

  async validate(): Promise<SuggestedContactsValidate> {
    try {
      const response = await MediaReleaseRecipient.where({
        mediaReleaseId: this.item!.id,
      })
        .stats({ select_all: "contact_ids" })
        .all();

      return {
        total: response.meta.stats.select_all.contact_ids.length,
        valid: response.meta.stats.select_all.contact_ids.some(
          (documentId: string) => {
            const [type] = documentId.split("_");

            return ["outlet", "influencer"].includes(type);
          }
        ),
      };
    } catch {
      return {
        total: 0,
        valid: false,
      };
    }
  }

  async add(selectedIds: string[], type?: string): Promise<void> {
    const { saveNewRecipientsForMediaRelease } = useMediaReleaseRecipient({
      mediaRelease: this.item!,
    });

    await saveNewRecipientsForMediaRelease(selectedIds);

    Notify.create({
      message: getLocaleText("ai_suggested_contacts_panel.recipients_added", {
        type,
      }),
    });
  }
}
